
<template>

  <div class="score">



    <h3>You got {{percentScore}}% correct.</h3>
    <div class="sub">When do you want to re-study this micro-note?</div>
  </div>

</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'


export default {
  computed: {
    ...mapState({
      keywords: state => state.studier.keywords,
    }),

    percentScore() {
      const keywords = _.values(this.keywords);
      if( !keywords.length) return null;
      let right = 0;

      _.each(keywords, (keyword) => {
        if(keyword && keyword.correct) right++;
      })
      return Math.round(right / keywords.length * 100);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.score {
  text-align: center;

}

</style>



// WEBPACK FOOTER //
// MicroNoteScore.vue?e7e77340